import { Injectable } from "@angular/core";
import * as CubiqTS from "shared/cubiq-model-multi-asset";
import {
  PRIMITIVE,
  ServiceMessageBroker,
  ServiceMessageBrokerFactory,
} from "shared/provider-webworker";
import { Subject } from "rxjs";
import { TraderGroupLookupService } from "../../lookup/model/impl/TraderGroupLookupService";
import { CubiqWorker } from "../../worker/CubiqWorker";
import {
  CHANNEL_SALES_APPROVAL_SERVICE,
  IOrderSalesApprovalRequestService,
} from "../IOrderSalesApprovalRequestService";
import { OrderSalesApprovalRequestPromiseService } from "./OrderSalesApprovalRequestPromiseService";
import { LoggerService } from "@bfx/logger";
const logger = LoggerService.for(__dirname);

import { BFXNotificationSubType } from "../../model/core/notifications/BFXNotificationSubType";
import { BFXNotificationType } from "../../model/core/notifications/BFXNotificationType";
import { BFXNotificationEventType } from "../../model/core/notifications/BFXNotificationEventType";
import { NotificationService } from "../../lookup/notification/impl/NotificationService";

@Injectable()
export class OrderSalesApprovalRequestPrimaryService extends OrderSalesApprovalRequestPromiseService {
  protected broker: ServiceMessageBroker;

  constructor(
    private worker: CubiqWorker,
    protected factory: ServiceMessageBrokerFactory,
    private notifService: NotificationService,
  ) {
    super();
    this.broker = factory.createMessageBroker(CHANNEL_SALES_APPROVAL_SERVICE, true, true);
    this.broker.registerMethod(
      "requestApproval",
      [PRIMITIVE, PRIMITIVE, PRIMITIVE],
      this.requestApproval.bind(this),
      PRIMITIVE,
    );
    this.broker.registerMethod(
      "initModelUpdateService",
      [PRIMITIVE],
      this.initModelUpdateService.bind(this),
      null,
      false,
    );
  }

  public requestApproval(
    ids: Array<string>,
    comment: string,
    action: CubiqTS.SalesApprovalAction,
  ): Promise<string> {
    let request = new CubiqTS.OrderSalesApprovalRequestImpl();

    if (ids != null && ids.length && ids.length > 0) {
      ids = ids.map((value: any) =>
        typeof value !== "string" && value.toString ? value.toString() : value,
      );
    }
    let subtype: BFXNotificationSubType = undefined;
    switch (action) {
      case CubiqTS.SalesApprovalAction.APPROVE:
        subtype = BFXNotificationSubType.APPROVE_FAIL;
        break;
      case CubiqTS.SalesApprovalAction.APPROVE_FILL:
        subtype = BFXNotificationSubType.APPROVE_FILL_FAIL;
        break;
      case CubiqTS.SalesApprovalAction.CANCEL_FILL:
        subtype = BFXNotificationSubType.CANCEL_FILL_FAIL;
        break;
      case CubiqTS.SalesApprovalAction.CLEAR_FILL:
        subtype = BFXNotificationSubType.CLEAR_FILL_FAIL;
        break;
      case CubiqTS.SalesApprovalAction.REJECT:
        subtype = BFXNotificationSubType.REJECTIONS_FAIL;
        break;
    }

    request.orderIds = ids;
    request.comment = comment;
    request.action = action;

    return new Promise<any>((resolve) => {
      this.worker.postServiceRequest(request).then(
        // SAme flow as in OrderAcceptancePrimaryService
        (response) => {
          this.augmentErrorResultIfNeeded(response, ids);
          this.notifService.handleErrors(
            response,
            BFXNotificationType.INTERVENTION_ACTION_FAIL,
            subtype,
          );
          resolve(response);
        },
        (rejectResponse) => {
          const error = this.createRejectError(rejectResponse);
          this.augmentErrorResultIfNeeded(error, ids);
          this.notifService.handleErrors(
            error,
            BFXNotificationType.INTERVENTION_ACTION_FAIL,
            subtype,
          );
          resolve(error);
        },
      );
    });
  }

  getModelNotificationFailureEventSubject(): Subject<CubiqTS.ConcreteEncodable> {
    return this.modelNotificationFailureEventSubject;
  }
}
